import { CoreEffects } from "./core.effects";
import { CatalogueEffects } from "./catalogue.effects";

export const Effects = [CoreEffects, CatalogueEffects];
